import { render, staticRenderFns } from "./realVideo.vue?vue&type=template&id=6a5df6d3&scoped=true&"
import script from "./realVideo.vue?vue&type=script&lang=js&"
export * from "./realVideo.vue?vue&type=script&lang=js&"
import style0 from "./realVideo.vue?vue&type=style&index=0&id=6a5df6d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5df6d3",
  null
  
)

export default component.exports